module.exports = __webpack_public_path__ + "static/esta.849be709.svg";